import { useState } from 'react'
import { useCreateTrack, useUpdateTrack } from '@/features/contract/statuses/hooks'
import type { StatusTrack } from '@/features/contract/statuses/types'
import { DialogShell } from './DialogShell'
import { CODE_REGEX, formatError } from './formatError'

export function TrackFormDialog({ editing, onClose }: { editing: StatusTrack | null; onClose: () => void }) {
  const create = useCreateTrack()
  const update = useUpdateTrack()
  const [code, setCode] = useState(editing?.code ?? '')
  const [labelPl, setLabelPl] = useState(editing?.labelPl ?? '')
  const [sortOrder, setSortOrder] = useState(editing?.sortOrder ?? 100)
  const [isActive, setIsActive] = useState(editing?.isActive ?? true)
  const [error, setError] = useState<string | null>(null)

  const submit = () => {
    setError(null)
    if (!editing && !CODE_REGEX.test(code)) { setError('Code: małe litery, cyfry, podkreślenia. Musi zaczynać się od litery.'); return }
    if (!labelPl.trim()) { setError('Etykieta nie może być pusta.'); return }
    if (editing) {
      update.mutate({ trackId: editing.id, payload: { labelPl, sortOrder, isActive } },
        { onSuccess: onClose, onError: e => setError(formatError(e)) })
    } else {
      create.mutate({ code, labelPl, sortOrder, isActive },
        { onSuccess: onClose, onError: e => setError(formatError(e)) })
    }
  }

  const isSubmitting = create.isPending || update.isPending

  return (
    <DialogShell
      title={editing ? `Edycja toru ${editing.code}` : 'Nowy tor'}
      onClose={onClose}
      isSubmitting={isSubmitting}
      error={error}
      onSubmit={submit}
    >
      <label className="grid gap-1">
        <span className="text-xs uppercase text-slate-500">Kod</span>
        <input value={code} onChange={e => setCode(e.target.value)} disabled={!!editing || isSubmitting} className="border rounded px-2 py-1 font-mono" />
      </label>
      <label className="grid gap-1">
        <span className="text-xs uppercase text-slate-500">Etykieta</span>
        <input value={labelPl} onChange={e => setLabelPl(e.target.value)} disabled={isSubmitting} className="border rounded px-2 py-1" />
      </label>
      <label className="grid gap-1">
        <span className="text-xs uppercase text-slate-500">Kolejność</span>
        <input type="number" value={sortOrder} onChange={e => setSortOrder(Number(e.target.value))} disabled={isSubmitting} className="border rounded px-2 py-1" />
      </label>
      <label className="flex items-center gap-2">
        <input type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} disabled={isSubmitting} />
        <span>Aktywne</span>
      </label>
    </DialogShell>
  )
}
